/**
 * Maps a studio's currency code to the corresponding default country code
 * for phone number input fields (ISO 3166-1 alpha-2, lowercase).
 */
const currencyToCountryCode: Record<string, string> = {
  USD: 'us',
  CAD: 'ca',
  AUD: 'au',
  NZD: 'nz',
  GBP: 'gb',
};

export function getCountryCodeFromCurrency(
  currencyName: string | undefined,
): string {
  if (!currencyName) return 'us';
  return currencyToCountryCode[currencyName] ?? 'us';
}
